import AppHeader from "../Header/header";
import AppHome from "../Home/home";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import JsonToTable from "../Post/postnew";
import About from "../About/about";
import Contact from "../Contact/contact";
import Footer from "../Footer/footer";
import Dashboard from "../Dashboard/dashboard";
import Signup from "../SignUp/signup";
import Login from "../Login/login";
import ShareButton from "../Share/ShareButton";
import PwaInstallPrompt from "../PwaInstallPrompt";
import LatestJobsPage from "../Home/LatestJobsPage";
import ResultsPage from "../Home/ResultsPage";
import AdmissionPage from "../Home/AdmissionPage";
import AnswerKeyPage from "../Home/AnswerKeyPage";
import AdmitCardPage from "../Home/AdmitCardPage";
import PrivacyPolicy from "../About/PrivacyPolicy";
import Disclaimer from "../About/Disclaimer";
import Terms from "../About/Terms";
import CurrentAffairsQuizAdmin from "../Admin/CurrentAffairsQuizAdmin";
import AdminQuizAttemptStatsPage from "../Admin/QuizAttemptStatsAdmin";
import AdminUsersPage from "../Admin/AdminUsersPage";
import AdminAnalyticsDashboardPage from "../Admin/AdminAnalyticsDashboardPage";
import AdminSyllabusQuestionBankPage from "../Admin/AdminSyllabusQuestionBankPage";
import AdminSyllabusAutomationPage from "../Admin/AdminSyllabusAutomationPage";
import {
  AdminSyllabusEditorPage,
  AdminSyllabusListPage,
  AdminSyllabusTestSeriesPage,
} from "../Admin/AdminSyllabusPages";
import QuizZonePage from "../QuizZone/QuizZonePage";
import TestSeriesPage from "../TestSeries/TestSeriesPage";
import { RequireAdminAuth, RequireAuth } from "./ProtectedRoute";
import {
  TopicQuizInstructionsPage,
  TopicQuizLeaderboardPage,
  TopicQuizListPage,
  TopicQuizPlayPage,
} from "../QuizZone/topicQuizzes";
import {
  CurrentAffairsQuizInstructionsPage,
  CurrentAffairsQuizLeaderboardPage,
  CurrentAffairsQuizListPage,
  CurrentAffairsQuizPlayPage,
} from "../CurrentAffairs/currentAffairs";
import {
  SyllabusBlueprintPage,
  SyllabusDetailPage,
  SyllabusExamKeyPage,
  SyllabusListPage,
} from "../Syllabus/SyllabusPages";
import { clearAuth, isAuthenticated } from "../config/auth";

const IDLE_LOGOUT_MS = 20 * 60 * 1000;

function IdleSessionManager() {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());

  useEffect(() => {
    const syncAuthState = () => {
      setAuthenticated(isAuthenticated());
    };

    window.addEventListener("userChange", syncAuthState);

    return () => {
      window.removeEventListener("userChange", syncAuthState);
    };
  }, []);

  useEffect(() => {
    if (!authenticated) return undefined;

    let timeoutId = null;

    const handleIdleLogout = () => {
      clearAuth();
      window.location.assign("/login");
    };

    const resetIdleTimer = () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      timeoutId = window.setTimeout(handleIdleLogout, IDLE_LOGOUT_MS);
    };

    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, resetIdleTimer, { passive: true });
    });

    resetIdleTimer();

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, resetIdleTimer);
      });
    };
  }, [authenticated]);

  return null;
}

function AppThenme() {
  return (
    <Router>
      <IdleSessionManager />
      <AppHeader />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<AppHome />} />
          <Route path="/latest-jobs" element={<LatestJobsPage />} />
          <Route path="/admit-card" element={<AdmitCardPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/admission" element={<AdmissionPage />} />
          <Route path="/answer-key" element={<AnswerKeyPage />} />
          <Route path="/syllabus" element={<SyllabusListPage />} />
          <Route path="/syllabus/exam/:examKey" element={<SyllabusExamKeyPage />} />
          <Route
            path="/syllabus/exam/:examKey/test-series-blueprint"
            element={<SyllabusBlueprintPage />}
          />
          <Route path="/syllabus/:slugWithId" element={<SyllabusDetailPage />} />
          <Route path="/quiz-zone" element={<QuizZonePage />} />
          <Route path="/test-series" element={<TestSeriesPage />} />
          <Route path="/quiz-zone/:subject/:topic/quizzes" element={<TopicQuizListPage />} />
          <Route
            path="/quiz-zone/:subject/:topic/:quizSlug/instructions"
            element={<TopicQuizInstructionsPage />}
          />
          <Route
            path="/quiz-zone/:subject/:topic/:quizSlug/start"
            element={<TopicQuizPlayPage />}
          />
          <Route
            path="/quiz-zone/:subject/:topic/:quizSlug/leaderboard"
            element={<TopicQuizLeaderboardPage />}
          />
          <Route path="/daily-current-affairs-quiz" element={<CurrentAffairsQuizListPage />} />
          <Route path="/job/:slugWithId" element={<JsonToTable />} />

          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/daily-current-affairs-quiz/:slugWithId/instructions"
              element={<CurrentAffairsQuizInstructionsPage />}
            />
            <Route
              path="/daily-current-affairs-quiz/:slugWithId/start"
              element={<CurrentAffairsQuizPlayPage />}
            />
            <Route
              path="/daily-current-affairs-quiz/:slugWithId/leaderboard"
              element={<CurrentAffairsQuizLeaderboardPage />}
            />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<Terms />} />

          <Route element={<RequireAdminAuth />}>
            <Route path="/admin/dashboard" element={<Navigate to="/admin/dashboard/quiz" replace />} />
            <Route path="/admin/dashboard/:adminSection" element={<CurrentAffairsQuizAdmin />} />
            <Route
              path="/admin/dashboard/:adminSection/:jobSection"
              element={<CurrentAffairsQuizAdmin />}
            />
            <Route path="/admin/analytics" element={<AdminAnalyticsDashboardPage />} />
            <Route path="/admin/quiz-attempt-stats" element={<AdminQuizAttemptStatsPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/syllabus" element={<AdminSyllabusListPage />} />
            <Route path="/admin/syllabus/automation" element={<AdminSyllabusAutomationPage />} />
            <Route path="/admin/syllabus/test-series" element={<AdminSyllabusTestSeriesPage />} />
            <Route path="/admin/syllabus/question-bank" element={<AdminSyllabusQuestionBankPage />} />
            <Route path="/admin/syllabus/new" element={<AdminSyllabusEditorPage />} />
            <Route path="/admin/syllabus/:id/edit" element={<AdminSyllabusEditorPage />} />
          </Route>
        </Routes>
        <Footer />
        <PwaInstallPrompt />
        <ShareButton />
      </div>
    </Router>
  );
}

export default AppThenme;
